import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTable$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTable extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '27ef38bed04d766559db531dbca64ea43f4c5048', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '54f08423a6294558def5a116491c7f894e6d0ad2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6965c83a44209f2fdd31294d2052452dc3f337c4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.5 5.5v2.75H8V5.5zm0 7V9.75H8v2.75zm0 1.5v2.5H8V14zm4 0v2.5h3V14zm4.5 0v2.5h2.5V14zm2.5-1.5H14V9.75h2.5zm-4 0h-3V9.75h3zM14 8.25h2.5V5.5H14zm-4.5 0h3V5.5h-3zM4.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-table", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-table"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-table":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTable$1);
            }
            break;
    } });
}

const CosmosIconTable = CosmosIconTable$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTable, defineCustomElement };
